import React from 'react';
import ImageScroller from 'components/revelo-ui/content/image-scroller';

const ImageScrollerTastic = ({ data }) => {
  return <ImageScroller columnCount={data.columnCount} images={data.images} />;
};

export default ImageScrollerTastic;
